import { render, staticRenderFns } from "./NewWarehouseDocumentPage.vue?vue&type=template&id=078fe160&scoped=true"
import script from "./NewWarehouseDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewWarehouseDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078fe160",
  null
  
)

export default component.exports